import * as Yup from 'yup';

export const formSchema = Yup.object().shape({
  firstName: Yup.string().required('First name is required'),
  lastName: Yup.string().required('Last name is required'),
  email: Yup.string()
    .email('Invalid email address')
    .required('Email address is required'),
  password: Yup.string()
    .required('Password is required')
    .matches(/^.{10,}$/, 'Must contain at least 10 characters'),
});
